import apiClient from './client';

export const TpaAxiosInstance = apiClient;